import { Accordion, Button, Modal, Tab, Table, Tabs } from 'react-bootstrap'
import { dayName, formatDate } from 'utils'
import { useState } from 'react'
import { APISERVICE } from '../../../services/api.service'
import { toast } from 'react-toastify'
import { FileUploadIcon } from '../Icons'
import { ArrowRightLeft, FileSearchCorner, FileText, FolderSearch, Save, X } from 'lucide-react'
import { ActividadMultiSelect } from 'components/domain/ActividadMultiSelect'
import { RecursoEducativoMultiSelect } from 'components/domain/RecursoEducativoMultiSelect'
import { empty } from 'utils/empty'
import { cn } from 'lib/utils'
import { getAccessToken } from 'helpers/getAccessToken'
import { IconLoader } from 'components/IconLoader'

const APIURL = process.env.REACT_APP_API_URL_RESOURCE
const controlPermanencia = {
    null: 'Ausencia',
    false: 'Incompleto',
    true: 'Completo',
}

export function ModalReportDetail({ show, report, onHide }) {
    const [showDetail, setShowDetail] = useState(false)
    const [loading, setLoading] = useState(false)
    const [detail, setDetail] = useState({
        fecha: '',
        tipo: 'permanencia',
        detalle: [],
        horario: {
            hora_inicio: '',
            hora_fin: '',
            control: '',
        },
    })

    if (!report) return
    const { asistencia, permanencia, nombre, grupo } = report // Subject

    const handleCloseModal = () => {
        onHide(false)
    }
    const openDetail = async (verificacion, tipo) => {
        const { fecha, hora_inicio, hora_fin, dia } = verificacion
        const idHorario = verificacion.horario_id
        if (!loading) {
            if (['asistencia', 'permanencia'].includes(tipo)) {
                try {
                    setLoading(true)
                    const url = `verificacion/get-detalle-${tipo}?fecha=${fecha}&idHorario=${idHorario}`
                    const response = await APISERVICE.get(url)
                    if (response.success) {
                        const { detalle } = response
                        let control = null
                        if (tipo === 'asistencia') {
                            control = verificacion.hora_entrada ? 'Asistencia' : 'Inasistencia'
                        } else if (tipo === 'permanencia') {
                            control = controlPermanencia[verificacion.completo]
                        }
                        setDetail({ fecha, tipo, detalle, horario: { hora_inicio, hora_fin, dia, control } })
                        setShowDetail(true)
                    }
                } catch (error) {
                    toast.error('Ocurrió un error al cargar la información')
                } finally {
                    setLoading(false)
                }
            }
        }
    }

    return (
        <>
            <Modal show={show} centered size='lg' scrollable>
                <Modal.Header>
                    <span className='h5 mb-0'>
                        Materia: {nombre} - Grupo: {grupo}
                    </span>
                </Modal.Header>
                <Modal.Body>
                    <Accordion defaultActiveKey={['0', '1', '2']} alwaysOpen>
                        <Accordion.Item eventKey='0'>
                            <Accordion.Header>Control asistencia</Accordion.Header>
                            <Accordion.Body>
                                {asistencia?.length > 0 ? (
                                    <Table striped responsive>
                                        <thead>
                                            <tr>
                                                <th>Fecha</th>
                                                <th>Horario</th>
                                                <th>Día</th>
                                                <th className='text-center'>Hora entrada</th>
                                                <th className='text-center'>Hora salida</th>
                                                <th className='text-center'>Detalle</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {asistencia.map((value, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>{formatDate(value.fecha, 'd/m/Y')}</td>
                                                        <td>
                                                            {`${value.hora_inicio.substring(0, 5)} - ${value.hora_fin.substring(0, 5)}`}
                                                        </td>
                                                        <td>{dayName(value.dia)}</td>
                                                        <td
                                                            className='text-center'
                                                            style={
                                                                !value.hora_entrada
                                                                    ? { color: 'red', backgroundColor: '#f8d7da' }
                                                                    : undefined
                                                            }
                                                        >
                                                            {value.hora_entrada || '-'}
                                                        </td>
                                                        <td
                                                            className='text-center'
                                                            style={
                                                                !value.tikeo_salida
                                                                    ? { color: 'red', backgroundColor: '#f8d7da' }
                                                                    : undefined
                                                            }
                                                        >
                                                            {value.hora_salida || '-'}
                                                        </td>
                                                        <td className='text-center'>
                                                            <Button
                                                                variant='blue'
                                                                className='py-0'
                                                                onClick={() => openDetail(value, 'asistencia')}
                                                            >
                                                                Ver
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </Table>
                                ) : (
                                    'Sin registros'
                                )}
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey='1'>
                            <Accordion.Header>Control permanencia</Accordion.Header>
                            <Accordion.Body>
                                {permanencia?.length > 0 ? (
                                    <Table striped responsive>
                                        <thead>
                                            <tr>
                                                <th>Fecha</th>
                                                <th>Horario</th>
                                                <th>Día</th>
                                                <th className='text-center'>Control</th>
                                                <th className='text-center'>Detalle</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {permanencia.map((value, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td>{formatDate(value.fecha, 'd/m/Y')}</td>
                                                        <td>
                                                            {`${value.hora_inicio.substring(0, 5)} - ${value.hora_fin.substring(0, 5)}`}
                                                        </td>
                                                        <td>{dayName(value.dia)}</td>
                                                        <td className='text-center'>
                                                            {value.completo ? (
                                                                'Completo'
                                                            ) : value.completo === false ? (
                                                                'Incompleto'
                                                            ) : (
                                                                <span className='text-danger'>Ausencia</span>
                                                            )}
                                                        </td>
                                                        <td className='text-center'>
                                                            <Button
                                                                variant='blue'
                                                                className='py-0'
                                                                onClick={() => openDetail(value, 'permanencia')}
                                                            >
                                                                Ver
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </Table>
                                ) : (
                                    'Sin registros'
                                )}
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant='blue' onClick={handleCloseModal}>
                        Volver
                    </Button>
                </Modal.Footer>
            </Modal>
            <ModalDetail show={showDetail} verificacion={detail} onHide={() => setShowDetail(false)} />
        </>
    )
}

/**
 * Modal de detalle de control de asistencia/permanencia de un horario.
 * @param {object} props Propiedades del componente.
 * @param {boolean} props.verificacion Especifica si el modal es visible o no.
 * @param {function} props.onHide Callback que se ejecuta para ocultar el modal.
 * @param {object | null} props.verificacion Detalle de control de asistencia/permanencia de un horario.
 * @returns Retorna el Modal de detalle de el control de asistencia/permanencia de un horario.
 */
export function ModalDetail({ show, verificacion, onHide }) {
    return (
        <Modal show={show} centered className='level-2' backdropClassName='level-2' scrollable>
            <Modal.Header>
                <span className='h5 mb-0'>Detalle de fecha {formatDate(verificacion.fecha, 'd/m/Y')}</span>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <div className='mb-3'>
                        <div>
                            <span className='fw-bold me-2'>Horario:</span>
                            {`${dayName(verificacion.horario?.dia)} ${verificacion.horario?.hora_inicio.substring(0, 5)} - ${verificacion.horario?.hora_fin.substring(0, 5)}`}
                        </div>
                        <div>
                            <span className='fw-bold me-2'>Control:</span>
                            {verificacion.horario.control}
                        </div>
                    </div>
                    {verificacion.tipo === 'asistencia' ? (
                        verificacion.detalle?.propietario && verificacion.detalle?.editable ? (
                            <ControlAsistenciaForm verificacion={verificacion} onCancel={onHide} />
                        ) : (
                            <ControlAsistenciaView verificacion={verificacion} />
                        )
                    ) : (
                        <ControlPermanenciaView verificacion={verificacion} />
                    )}
                </div>
            </Modal.Body>
            {!(
                verificacion.tipo === 'asistencia' &&
                verificacion.detalle?.propietario &&
                verificacion.detalle?.editable
            ) && (
                <Modal.Footer>
                    <Button variant='outline-blue' onClick={onHide}>
                        <X className='size-4' />
                        Cerrar
                    </Button>
                </Modal.Footer>
            )}
        </Modal>
    )
}

function ControlAsistenciaView({ verificacion }) {
    return (
        <div>
            <div className='fw-bold border-bottom border-dark mb-2'>Contenido avanzado</div>
            <div className='mb-2' style={{ whiteSpace: 'pre-line' }}>
                <span className='fw-bold me-2'>Descripción:</span>
                {verificacion.detalle?.descripcion_actividades || 'Ninguna'}
            </div>
            <div className='mb-2'>
                <span className='fw-bold me-2'>Actividades:</span>
                {verificacion.detalle?.payload_actividades?.actividades.length
                    ? verificacion.detalle.payload_actividades.actividades.map((a) => <div>- {a.descripcion}</div>)
                    : '-'}
            </div>
            <div className='mb-2'>
                <span className='fw-bold me-2'>Recursos utilizados:</span>
                {verificacion.detalle?.payload_actividades?.recursos_educativos.length
                    ? verificacion.detalle.payload_actividades.recursos_educativos.map((re) => (
                          <div>- {re.descripcion}</div>
                      ))
                    : '-'}
            </div>
            <div className='mb-3'>
                <span className='fw-bold me-2'>Archivo:</span>
                {verificacion.detalle?.url_actividades ? (
                    <a href={`${APIURL}${verificacion.detalle.url_actividades}`} target='_blank' rel='noreferrer'>
                        Ver adjunto
                    </a>
                ) : (
                    '-'
                )}
            </div>
            <div className='fw-bold border-bottom border-dark mb-2'>Justificación</div>
            <div className='mb-2' style={{ whiteSpace: 'pre-line' }}>
                <span className='fw-bold me-2'>Descripción:</span>
                {verificacion.detalle?.descripcion_justificacion || 'Ninguna'}
            </div>
            <div>
                <span className='fw-bold me-2'>Archivo:</span>
                {verificacion.detalle?.url_justificacion ? (
                    <a href={`${APIURL}${verificacion.detalle.url_justificacion}`} target='_blank' rel='noreferrer'>
                        Ver adjunto
                    </a>
                ) : (
                    '-'
                )}
            </div>
        </div>
    )
}

function ControlPermanenciaView({ verificacion }) {
    return (
        <div>
            <Table striped responsive className='text-center mb-0'>
                <thead>
                    <tr>
                        <th>Hora</th>
                        <th>Tiqueo</th>
                    </tr>
                </thead>
                <tbody>
                    {verificacion.detalle?.length > 0 ? (
                        verificacion.detalle?.map((value, index) => (
                            <tr key={index}>
                                <td>{value.hora_tikeo}</td>
                                <td>{value.tikeo ? 'Si' : <span className='text-danger'>No</span>}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={2}>Sin tiqueos registrados</td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </div>
    )
}

function ControlAsistenciaForm({ verificacion, onCancel }) {
    return (
        <div>
            <Tabs defaultActiveKey='actividades' justify>
                <Tab eventKey='actividades' title='Contenido avanzado'>
                    <ContenidoAvanzadoForm verificacion={verificacion} onCancel={onCancel} className='pt-3' />
                </Tab>
                <Tab eventKey='justificacion' title='Justificación'>
                    <JustificacionForm verificacion={verificacion} onCancel={onCancel} className='pt-3' />
                </Tab>
            </Tabs>
        </div>
    )
}

function ContenidoAvanzadoForm({ verificacion, onCancel, className }) {
    const [values, setValues] = useState({
        file: null,
        descripcion: verificacion.detalle?.descripcion_actividades ?? '',
        actividades: verificacion.detalle?.payload_actividades?.actividades ?? [],
        recursos_educativos: verificacion.detalle?.payload_actividades?.recursos_educativos ?? [],
    })
    const [errors, setErrors] = useState({})
    const [loading, setLoading] = useState(false)

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (verificacion.detalle) {
            setLoading(true)
            const errors = validate(values)
            if (errors) {
                setErrors(errors)
            } else {
                const formData = new FormData()
                formData.append('verificacion_id', verificacion.detalle.id)
                formData.append('descripcion', values.descripcion)
                if (values.file) {
                    formData.append('file', values.file)
                }
                if (values.actividades.length || values.recursos_educativos.length) {
                    formData.append(
                        'payload',
                        JSON.stringify({
                            actividades: values.actividades,
                            recursos_educativos: values.recursos_educativos.map((re) => ({
                                id: re.id,
                                descripcion: re.descripcion,
                            })),
                        }),
                    )
                } else {
                    formData.append('payload', null)
                }
                try {
                    const token = getAccessToken()
                    const response = await fetch(
                        `${process.env.REACT_APP_API_URL}/verificacion/upsert-contenido-avanzado`,
                        {
                            method: 'POST',
                            body: formData,
                            headers: { Authorization: `Bearer ${token}` },
                        },
                    )
                    const data = await response.json()
                    if (response.ok) {
                        toast.success(data.message)
                    } else if (response.status >= 400) {
                        toast.error(data.message ?? 'Error')
                    }
                } catch (error) {
                    toast.error('Ocurrió un error en el servidor')
                }
            }
            setLoading(false)
        }
    }
    const handleChange = (e) => {
        const { name } = e.target
        if (name === 'file') {
            setValues((prev) => ({ ...prev, [name]: e.target.files?.[0] ?? null }))
        } else {
            setValues((prev) => ({ ...prev, [name]: e.target.value }))
        }
        if (errors[name]) setErrors((prev) => ({ ...prev, [name]: '' }))
    }

    const filename = verificacion.detalle?.url_actividades ?? ''

    return (
        <form onSubmit={handleSubmit} className={className}>
            <div className='mb-3'>
                <label className='form-label'>
                    Contenido avanzado <span className='text-danger'>*</span>
                </label>
                <textarea
                    name='descripcion'
                    value={values.descripcion}
                    onChange={handleChange}
                    placeholder='Descripción de lo avanzado en la clase'
                    className={cn('form-control', errors.descripcion && 'is-invalid')}
                />
                <div className='invalid-feedback'>{errors.descripcion}</div>
            </div>
            <div className='mb-3'>
                <label className='form-label'>Actividades</label>
                <ActividadMultiSelect
                    name='actividades'
                    value={values.actividades}
                    onChange={handleChange}
                    multiSelection
                    valueAsOption
                />
            </div>
            <div className='mb-3'>
                <label className='form-label'>Recursos utilizados</label>
                <div className='position-relative'>
                    <RecursoEducativoMultiSelect
                        name='recursos_educativos'
                        value={values.recursos_educativos}
                        onChange={handleChange}
                        multiSelection
                        valueAsOption
                        menuStyle={{ width: '100%' }}
                    />
                </div>
            </div>
            {filename ? (
                <div className='mb-3'>
                    <label className='form-label'>Archivo</label>
                    <FileField
                        file={values.file}
                        fileUrl={`${APIURL}${filename}`}
                        filename={`actividades.${filename.split('.').slice(-1)[0] ?? ''}`}
                        onChange={handleChange}
                        id='actividades-file'
                    />
                    {errors.file && <div className='msg-error mt-1'>{errors.file}</div>}
                </div>
            ) : (
                <div className='mb-3'>
                    <label>Archivo</label>
                    <span className='d-block text-primary text-sm mb-1'>* Opcionalmente puede adjuntar un archivo</span>
                    <FileField file={values.file} onChange={handleChange} id='actividades-file' />
                    {errors.file && <div className='msg-error mt-1'>{errors.file}</div>}
                </div>
            )}
            <div className='d-flex gap-2 pt-3 px-3 border-top' style={{ margin: '0 -1rem' }}>
                <Button variant='outline-blue' onClick={onCancel}>
                    <X className='size-4' />
                    Cancelar
                </Button>
                <Button type='submit' variant='blue' className='flex-1' disabled={loading}>
                    <IconLoader loading={loading}>
                        <Save className='size-4' />
                    </IconLoader>
                    Actualizar contenido avanzado
                </Button>
            </div>
        </form>
    )
}

function JustificacionForm({ verificacion, onCancel, className }) {
    const [values, setValues] = useState({
        file: null,
        descripcion: verificacion.detalle?.descripcion_justificacion ?? '',
    })
    const [errors, setErrors] = useState({})
    const [loading, setLoading] = useState(false)

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (verificacion.detalle) {
            setLoading(true)
            const errors = validate(values)
            if (errors) {
                setErrors(errors)
            } else {
                const formData = new FormData()
                formData.append('verificacion_id', verificacion.detalle.id)
                formData.append('descripcion', values.descripcion)
                if (values.file) {
                    formData.append('file', values.file)
                }
                try {
                    const token = getAccessToken()
                    const response = await fetch(`${process.env.REACT_APP_API_URL}/verificacion/upsert-justificacion`, {
                        method: 'POST',
                        body: formData,
                        headers: { Authorization: `Bearer ${token}` },
                    })
                    const data = await response.json()
                    if (response.ok) {
                        toast.success(data.message)
                    } else if (response.status >= 400) {
                        toast.error(data.message ?? 'Error')
                    }
                } catch (error) {
                    toast.error('Ocurrió un error en el servidor')
                }
            }
            setLoading(false)
        }
    }
    const handleChange = (e) => {
        const { name } = e.target
        if (name === 'file') {
            setValues((prev) => ({ ...prev, [name]: e.target.files?.[0] ?? null }))
        } else {
            setValues((prev) => ({ ...prev, [name]: e.target.value }))
        }
        if (errors[name]) setErrors((prev) => ({ ...prev, [name]: '' }))
    }

    const filename = verificacion.detalle?.url_justificacion ?? ''

    return (
        <form onSubmit={handleSubmit} className={className}>
            <div className='mb-3'>
                <label className='form-label'>Justificación</label>
                <textarea
                    name='descripcion'
                    value={values.descripcion}
                    onChange={handleChange}
                    placeholder='Ejm: Tuve problemas de conexión'
                    className={cn('form-control', errors.descripcion && 'is-invalid')}
                />
                <div className='invalid-feedback'>{errors.descripcion}</div>
            </div>
            {filename ? (
                <div className='mb-3'>
                    <label className='form-label'>Archivo</label>
                    <FileField
                        file={values.file}
                        fileUrl={`${APIURL}${filename}`}
                        filename={`justificacion.${filename.split('.').slice(-1)[0] ?? ''}`}
                        onChange={handleChange}
                        id='justificacion-file'
                    />
                    {errors.file && <div className='msg-error mt-1'>{errors.file}</div>}
                </div>
            ) : (
                <div className='mb-3'>
                    <label>Archivo</label>
                    <span className='d-block text-primary text-sm mb-1'>* Opcionalmente puede adjuntar un archivo</span>
                    <FileField file={values.file} onChange={handleChange} id='justificacion-file' />
                    {errors.file && <div className='msg-error mt-1'>{errors.file}</div>}
                </div>
            )}
            <div className='d-flex gap-2 pt-3 px-3 border-top' style={{ margin: '0 -1rem' }}>
                <Button variant='outline-blue' onClick={onCancel}>
                    <X className='size-4' />
                    Cancelar
                </Button>
                <Button type='submit' variant='blue' className='flex-1' disabled={loading}>
                    <IconLoader loading={loading}>
                        <Save className='size-4' />
                    </IconLoader>
                    Actualizar justificación
                </Button>
            </div>
        </form>
    )
}

function FileField({ file, fileUrl, filename, onChange, id }) {
    const [hasFile, setHasFile] = useState(!!fileUrl)

    return hasFile ? (
        <div className='d-flex gap-3'>
            <FileText className='size-16 text-secondary' />
            <div className='flex-1'>
                <div>
                    <div className='text-sm'>Nombre del archivo:</div>
                    <div className='font-medium'>{filename}</div>
                </div>
            </div>
            <div className='d-flex flex-column gap-1 ps-3 border-start'>
                <Button size='sm' onClick={() => setHasFile(false)}>
                    <ArrowRightLeft className='size-4' />
                    Reemplazar
                </Button>
                <Button size='sm' as='a' href={fileUrl} target='_blank'>
                    <FileSearchCorner className='size-4' />
                    Abrir archivo
                </Button>
            </div>
        </div>
    ) : (
        <div className='d-flex gap-3'>
            <div className='flex-1'>
                <label className='custom-file mt-0' htmlFor={id}>
                    <span className='custom-file-icon'>
                        <FileUploadIcon />
                    </span>
                    {file ? file.name : 'Seleccionar archivo'}
                </label>
                <input
                    type='file'
                    name='file'
                    id={id}
                    accept='.pdf,.doc,.docx,.jpg,.png,.jpeg'
                    hidden
                    onChange={onChange}
                />
            </div>
            {!!fileUrl && (
                <div className='ps-3 border-start'>
                    <Button
                        size='sm'
                        onClick={(e) => {
                            setHasFile(true)
                            if (file) {
                                onChange({ target: { id, name: 'file', files: [] } })
                            }
                        }}
                    >
                        <FolderSearch className='size-4' />
                        Ver archivo
                    </Button>
                </div>
            )}
        </div>
    )
}

function validate(values) {
    const errors = {}
    if (empty(values.descripcion)) {
        errors.descripcion = 'Requerido'
    } else {
        if (values.descripcion.length > 500) {
            errors.descripcion = 'Longitud máxima de 500 caracteres'
        }
    }
    if (values.file) {
        const ext = values.file.name.split('.').slice(-1)[0] ?? ''
        if (!['pdf', 'doc', 'docx', 'png', 'jpg', 'jpeg'].includes(ext)) {
            errors.file = 'Formato no valido'
        }
    }
    return empty(errors) ? null : errors
}
